import useCustomRouter from './useCustomRouter';

// this hook is not nice solution. I hope it will disapear
// component should be depends only on props
// todo: fix checkout components and use them everywhere
export const useIsMyAccount = () => {
    const { asPath } = useCustomRouter();
    return asPath.startsWith('/my-account');
};
